export default "City Bowling Holbæk has a few different activities besides bowling. They opened their first escape room in Martch 2022.";